import React, { useState } from 'react';

const METRICS = [
  { value: 'response', label: '响应时间' },
  { value: 'online', label: '在线人数' }
];

export default function AiAnalysisCard({ projectId, fontSize = 13 }) {
  const [metrics, setMetrics] = useState([]);
  const [analysis, setAnalysis] = useState('');
  const [loading, setLoading] = useState(false);

    const toggleMetric = (val) => {
    setMetrics(prev => {
      const next = prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val];
      // 确保至少勾选一个
      return next.length > 0 ? next : prev;
    });
  };

  const generate = async () => {
    if (metrics.length === 0) return alert('请至少选择一个指标');
    setLoading(true);
    try {
      const payload = { projectId, metrics };
      const res = await fetch('/api/monitor/ai-analysis', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-token': localStorage.getItem('notes_token') },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      setAnalysis(json.analysis || '分析失败');
    } catch (e) {
      setAnalysis('分析失败，请重试');
    }
    setLoading(false);
  };

  return (
    <div style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <h3 style={{ margin: 0, fontSize: 13 }}>🤖 监控分析</h3>
          {METRICS.map(m => (
            <label key={m.value} style={{ fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
              <input
                type="checkbox"
                checked={metrics.includes(m.value)}
                onChange={() => toggleMetric(m.value)}
                style={{ margin: 0 }}
              />
              {m.label}
            </label>
          ))}
        </div>
        <button onClick={generate} disabled={loading || metrics.length === 0} style={{ padding: '4px 12px', border: 'none', borderRadius: 6, background: '#6366F1', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
          {loading ? '生成中...' : '生成分析'}
        </button>
      </div>

      {analysis && (
        <div style={{ fontSize: fontSize || 13, lineHeight: 1.8, color: '#374151', whiteSpace: 'pre-wrap', padding: '12px', background: '#f9fafb', borderRadius: 6, marginTop: 8 }}>
          {analysis}
        </div>
      )}
    </div>
  );
}
